import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

import { campaignsEndpoints as endpoints } from '@/api/endpoints';
import { ApiError } from '@/api/fetcher';

import { API } from './useCampaignSubscribers';

export const useResumeCampaignSubscriber = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const { mutateAsync: resumeSubscriberAsync, status: resumeSubscriberStatus } = useMutation({
    mutationFn: ({ campaignId, subscriberId }: { campaignId: string; subscriberId: string }) =>
      API.resumeCampaignSubscriber(campaignId, subscriberId),
    onSuccess: (_data, variables) => {
      // Resume rewrites the journey; refetch list + subscriber.
      queryClient.invalidateQueries({
        queryKey: [endpoints.campaignSubscribers(variables.campaignId)],
      });
      queryClient.invalidateQueries({
        queryKey: [endpoints.campaignSubscriber(variables.campaignId, variables.subscriberId)],
      });
    },
    onError: (error: ApiError) => {
      let message = error.message;
      if (error.statusCode === 409) {
        message = t('campaigns.subscriber_not_resumable');
      } else if (error.statusCode === 400) {
        message = t('campaigns.subscriber_resume_unavailable');
      }
      toast.error(message);
    },
  });

  return { resumeSubscriberAsync, resumeSubscriberStatus };
};
